import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';

import { getDuplicateCompaniesCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/contact/index/companies/duplicates/duplicates_pagination';

export function DuplicateCompaniesView({ isLoading, totalCount }) {
  const renderEmptyState = () => (
    <div className="no-results-panel" name="no-results-panel">
      <FontAwesomeIcon className="text-muted my-4" icon={faSearch} size="5x" />
      <h4 className="mt-4">
        <strong className="text-lg">No duplicate contacts found</strong>
      </h4>
    </div>
  );

  const renderTable = () => (
    <React.Fragment>
      <DuplicatesTable />
      <DuplicatesPagination />
    </React.Fragment>
  );

  const renderResults = () => {
    if (isLoading) return <LoadingSpinner />;
    if (totalCount > 0) return renderTable();
    return renderEmptyState();
  };

  return (
    <React.Fragment>
      <DuplicatesPageHeader />
      <DuplicatesPageTopbar />
      {renderResults()}
    </React.Fragment>
  );
}

DuplicateCompaniesView.propTypes = {
  isLoading: PropTypes.bool,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicateCompaniesCount(state)
});

export default connect(mapStateToProps)(DuplicateCompaniesView);
